<template>
  <div class="app-container" style="padding: 0;">
    <div class="wt-tab-info-card">
      <el-tabs v-model="activeTabName" type="card">
        <el-tab-pane label="实时统计" name="1"></el-tab-pane>
        <el-tab-pane label="投递统计" name="2"></el-tab-pane>
        <el-tab-pane label="清运统计" name="3"></el-tab-pane>
        <el-tab-pane label="财务统计" name="4"></el-tab-pane>
      </el-tabs>
      <OneDetail v-if="activeTabName === '1'"></OneDetail>
      <TwoDetail v-else-if="activeTabName === '2'"></TwoDetail>
      <ThreeDetail v-else-if="activeTabName === '3'"></ThreeDetail>
      <FourDetail v-else-if="activeTabName === '4'"></FourDetail>
    </div>
  </div>
</template>

<script>

export default {
  name: 'WorkbenchIndex',
  data() {
    return {
      activeTabName: '1'
    }
  },
  methods: {}
}
</script>
